// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"94ff5187","160":"d12b4670","208":"253fb789","293":"f2dbe920","516":"a755525b","519":"54f097b2","840":"6e8e4826","917":"db7dba75","946":"2194f7cf"}[chunkId] + ".chunk.js";
};